import { Box, Button } from '@mui/material';
import React, { useContext, useState } from 'react'
import Joyride from 'react-joyride';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';

const steps = [
    {
        target: ".report-tour-1",
        title: "Summary Statistics",
        content: "These cards display a quick summary of your publication activity such as approved, for approved, posted, and saved items.",
        placement: "bottom"
    },
    {
        target: ".report-tour-2",
        title: "Content Type",
        content: "Filter engagement data by content type such as Articles, News, or Updates.",
        placement: "bottom"
    },
    {
        target: ".report-tour-3",
        title: "Publication Engagement",
        content: "This table shows engagement metrics including reactions, comments, saves, and views for each publication.",
        placement: "top"
    }
];

export const Report = () => {
    const { tool_state, personalization_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { walkthrough } = personalization_state

    const [stepIndex, setStepIndex] = useState(0);

    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8);
    const tool_id =  process.env.REACT_APP_TID_BIZ;

    const handleJoyrideCallback = async (data) => {
        const { status, action, index, type } = data;        

        let body = {
            user_id: user_id,
            tool_id: tool_id,
            feature_name: 'report',
            personalization:[{sf_name: 'report', status: 1}]
        }

        if (type === 'step:after' && action === 'next') {    
            setStepIndex(index + 1);
        }
        
        if (['close', 'stop'].includes(action)) {
            walkthrough.set(prev => ({...prev, report: false}))
            setStepIndex(0);
            await rqx.post(`<<global>>/${env()}/personalization/create`, body)
        }
    };	
    
    return (
        <Joyride
            run={walkthrough.data.report}
            continuous
            disableOverlayClose={true}
            steps={steps}
            stepIndex={stepIndex}
            showSkipButton={true}
            callback={handleJoyrideCallback}
            tooltipComponent={CustomComponent}
        />
    )
}

export const CustomComponent = ({ step, index, totalSteps, primaryProps, closeProps, tooltipProps }) => {
    return (
        <Box {...tooltipProps} width="340px" p={2} bgcolor="#fff" borderRadius="8px">
            <Box fontSize="14px" fontWeight="600">{step.title}</Box>
            <Box fontSize="12px" py="4px">{step.content}</Box>

            <Box width="100%" display="flex" justifyContent="flex-end"  gap="4px">
                <Button {...closeProps} variant={index === 2 ? 'contained' : 'Skip'} disableElevation sx={{ fontSize: '12px', p: '4px 16px' }}>
                    {index === 2 ? 'Got it!' : 'Skip'}
                </Button>
                {
                    index !== 2 &&
                    <Button {...primaryProps} variant="contained" disableElevation sx={{fontSize: '12px', p: '4px 16px'}}>
                        Next
                    </Button>
                }
            </Box>
        </Box>
    );
};
